import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import EditIcon from '../assets/icons/editIcon.svg';
import { Button, ButtonTypes } from '../components';
import { IAppStore } from '../HomeWorkouts';
import theme from '../theme';
import { InitialsCircle } from '../ui/components';
import { defaultScale, scaleText } from '../utils/scaling';
import { ISwitchMemberUserProfile } from './reducer';
import { loadChooseProfileColorScreen, loadConfirmCancelScreen, loadSetProfilePinScreen } from './actions';
import { familyMemberProfileColorSelector, memberHasPinSelector } from './selector';
import { NavigatorService } from '../utils/NavigatorService';
import build from '../config/build';

interface IProps {
  navigation: any;
  t: (s: string) => string;
  navigateToProfileColorScreen: (profileColor: string) => void;
  navigateToConfirmRemoveScreen: (userProfile: ISwitchMemberUserProfile) => void;
  navigateToSetProfilePin: () => void;
  profileColor: string;
  memberHasPin: boolean;
}

class MemberSetttingsComponent extends React.Component<IProps> {
  public render() {
    const {
      t,
      navigateToProfileColorScreen,
      navigateToConfirmRemoveScreen,
      navigateToSetProfilePin,
      profileColor,
      memberHasPin,
    } = this.props;
    const { userProfile }: {userProfile: ISwitchMemberUserProfile} = this.props.navigation.state.params;
    const { isElite } = build.variant;

    return (
      <View style={styles.container}>
        <TouchableOpacity
          style={styles.initialsAndEditIconContainer}
          onPress={() => {
            navigateToProfileColorScreen(profileColor);
          }}
        >
          <InitialsCircle
            initials={userProfile.initials}
            backgroundColor={profileColor}
            color={theme.WHITE}
            textStyle={styles.initialsText}
            size={defaultScale(80)}
          />
          <EditIcon
            style={styles.editIcon}
            fill={theme.BLACK}
            width={defaultScale(18)}
            height={defaultScale(18)}
          />
        </TouchableOpacity>
        <Text style={styles.nameText}>{userProfile.firstname}</Text>
        <Text style={styles.sessionText}>{t('sessionActive')}</Text>
        {isElite && <Button
          title={t('endMySession')}
          buttonType={ButtonTypes.OUTLINE}
          contentContainerStyle={styles.button}
          overrideFontStyles={styles.buttonText}
          onPress={() => {
            NavigatorService.navigateContainerOne('EliteLoading')
          }}
        />}
        
        <Button
          title={ memberHasPin ? t('changePin') : t('setMyProfilePin')}
          buttonType={ButtonTypes.OUTLINE}
          onPress={navigateToSetProfilePin}
          containerStyle={[styles.button, { marginTop: defaultScale(15) }]}
          overrideFontStyles={styles.buttonText}
        />
        {!userProfile.isFamilyPlanAdmin && (
          <Button
            title={t('leaveFamilyMembership')}
            buttonType={ButtonTypes.OUTLINE}
            containerStyle={[styles.button, { marginTop: defaultScale(15) }]}
            overrideFontStyles={styles.buttonText}
            onPress={() => navigateToConfirmRemoveScreen(userProfile)}
          />
        )}
      </View>
    );
  }
}

const mapStateToProps = (state: IAppStore) => {
 return {
   profileColor: familyMemberProfileColorSelector(state),
   memberHasPin: memberHasPinSelector(state),
 };
};

const mapDispatchToProps = ( dispatch: any, ownProps: any ) => {
  const navigation = ownProps.navigation;
  return {
        navigateToProfileColorScreen: (profileColor) =>
          dispatch(loadChooseProfileColorScreen(navigation, profileColor)),
        navigateToConfirmRemoveScreen: (userProfile: ISwitchMemberUserProfile) =>
          dispatch(loadConfirmCancelScreen(navigation, userProfile)),
        navigateToSetProfilePin : () => dispatch(loadSetProfilePinScreen(navigation)),
    };
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.WHITE,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: defaultScale(12),
  },
  initialsAndEditIconContainer: {
    position: 'relative',
    width: defaultScale(80),
    height: defaultScale(80),
  },
  initialsText: {
    fontFamily: theme.Custom700,
    fontSize: defaultScale(33),
    color: theme.WHITE,
  },
  editIcon: {
    position: 'absolute',
    left: '75%',
    top: '5%',
    zIndex: 10,
  },
  button: {
    width: '100%',
    height: defaultScale(45),
  },
  sessionText: {
    ...theme.textStyle.bodyCopyReg,
    marginBottom: defaultScale(30),
  },
  nameText: {
    fontFamily: theme.Custom700,
    fontSize: 21,
    color: theme.BLACK,
    marginVertical: 12,
  },
  buttonText: {
    fontFamily: theme.Custom700,
    fontSize: scaleText(16),
  },
});

export const MemberSetttings = translate(['familyPlan'])(
  connect(mapStateToProps, mapDispatchToProps)(MemberSetttingsComponent),
);
